module.exports = __webpack_public_path__ + "static/media/oitonegative.f2b3dd05.svg";